import Alert from '@mui/material/Alert';
import React from 'react';

import Arranger from '~/client/components/base/arranger';
import Spacer, { spc } from '~/client/components/base/spacer';

interface Props {
  className?: string;
}

const Alerts: React.FC<Props> = ({ className }) => {
  return (
    <Arranger className={className} direction="row">
      <Alert color="error">This is an error alert</Alert>
      <Spacer px={spc.xs} />
      <Alert color="warning">This is a warning alert</Alert>
      <Spacer px={spc.xs} />
      <Alert color="success">This is a success alert</Alert>
    </Arranger>
  );
};

export default Alerts;
